import React from 'react';
import { Box, Typography, Button, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Helmet } from 'react-helmet';
import ImageSlider from './ImageSlider.Component';
import FAQs from './FAQ.Component';

const Home = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <Helmet>
        <title>Home - HawkClient</title>
        <meta
          name="description"
          content="HawkClient - A developer friendly offline only API client designed for efficient API testing and development. Test, debug, and manage APIs efficiently with a free Postman/Insomnia alternative."
        />
      </Helmet>
      <Box
        sx={{
          padding: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          minHeight: '50vh',
          // backgroundColor: '#f5f5f5',
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom>
          HawkClient: A developer and git friendly offline-only API client
        </Typography>
        <Typography color="textSecondary">
          A developer and git friendly offline-only API client that provides comprehensive solution for API testing
        </Typography>
        <Typography color="textSecondary">
          and management with the support for team collaboration using git or any other version control system.
        </Typography>
        <Box style={{ display: "flex", flexDirection: 'row' }}>

          <Box style={{ display: "flex", flexGrow: 1, alignItems: 'center', justifyContent: 'center' }}>
            {/* <img
              src="/theme-screenshot/Light.png"
              alt="hawkclient"
              style={{
                width: isMobile ? '100%' : '70%',
                // maxWidth: '800px',
                height: 'auto',
                display: 'block',
                objectFit: 'contain',
                marginTop: '16px',
              }}
            /> */}
            <ImageSlider />
          </Box>
        </Box>
        <Box style={{ display: "flex", width: "400px", alignItems: 'center', justifyContent: 'center' }}>
          <Button
            variant="contained"
            color="primary"
            sx={{ marginTop: 3, textTransform: 'none' }}
            onClick={() => navigate('/download')}
          >
            Download
          </Button>
        </Box>
        <Box style={{ display: "flex", flexDirection: isMobile ? 'column' : 'row', marginTop: "100px", padding: '20px' }}>
          <Box style={{ display: "flex", flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: isMobile ? '100%' : '50%' }}>
            <Typography variant="h4" component="h1" >Team Collaboration</Typography>
            <Typography>Team Collaboration using <strong>git</strong> or any other version control system</Typography>
            <Typography>HawkClient stores the requests in <strong>yaml files</strong> that makes it more readable and easier to share with team through git</Typography>
          </Box>

          <Box style={{ display: "flex", width: isMobile ? '100%' : '50%', alignItems: 'center', justifyContent: 'center' }}>
            <img
              src="/git-collab.png"
              alt="hawkclient"
              style={{
                width: '90%',
                // maxWidth: '800px',
                height: 'auto',
                display: 'block',
                objectFit: 'contain',
                marginTop: '16px',
              }}
            />
          </Box>
        </Box>
        <Box style={{ display: "flex", flexDirection: isMobile ? 'column-reverse' : 'row', marginTop: "100px", marginBottom: "100px", padding: '20px' }}>
          <Box style={{ display: "flex", width: isMobile ? '100%' : '50%', alignItems: 'center', justifyContent: 'center' }}>
            <img
              src="/flows/APIFlows.png"
              alt="APIFlows"
              style={{
                width: '90%',
                // maxWidth: '800px',
                height: 'auto',
                display: 'block',
                objectFit: 'contain',
                marginTop: '16px',
              }}
            />
          </Box>
          <Box style={{ display: "flex", flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: isMobile ? '100%' : '50%' }}>
            <Typography variant="h4" component="h1" >API Flows</Typography>
            <Typography>Effortlessly design, create, and execute your API Flows with a seamless drag-and-drop interface to test the entire workflow efficiently.</Typography>
          </Box>
        </Box>
        <Box style={{ display: "flex", flexDirection: isMobile ? 'column' : 'row', marginTop: "100px", marginBottom: "100px", padding: '20px' }}>
          <Box style={{ display: "flex", flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: isMobile ? '100%' : '50%' }}>
            <Typography variant="h4" component="h1" >OpenAPI & Swagger Integration</Typography>
            <Typography>Effortlessly create and design your APIs at the collection level using Swagger YAML. Simplify API documentation and testing with full OpenAPI support.</Typography>
          </Box>
          <Box style={{ display: "flex", width: isMobile ? '100%' : '50%', alignItems: 'center', justifyContent: 'center' }}>
            <img
              src="/openAPI.png"
              alt="openAPI"
              style={{
                width: '90%',
                // maxWidth: '800px',
                height: 'auto',
                display: 'block',
                objectFit: 'contain',
                marginTop: '16px',
              }}
            />
          </Box>
        </Box>
        <Box style={{ display: "flex", flexDirection: isMobile ? 'column-reverse' : 'row', marginTop: "100px", marginBottom: "100px", padding: '20px' }}>
          <Box style={{ display: "flex", width: isMobile ? '100%' : '50%', alignItems: 'center', justifyContent: 'center' }}>
            <img
              src="/docs/hawkclient-cli.png"
              alt="hawkclient-cli"
              style={{
                width: '90%',
                // maxWidth: '800px',
                height: 'auto',
                display: 'block',
                objectFit: 'contain',
                marginTop: '16px',
              }}
            />
          </Box>
          <Box style={{ display: "flex", flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: isMobile ? '100%' : '50%' }}>
            <Typography variant="h4" component="h1" >HawkClient CLI</Typography>
            <Typography>Easily run your API collections using <strong>hawkclient-cli</strong>. Ideal for automating workflows in your CI/CD pipeline.</Typography>
          </Box>
        </Box>
        <FAQs />
      </Box>
    </>
  );
};

export default Home;
